import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ae0007',
    ecrans: [
        '00-2'
    ]
});
